import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { INDUSTRIES_API } from "../../Utils/apis";


export const fetchIndustries = createAsyncThunk("fetchIndustries", async () => {
    const res = await fetch(INDUSTRIES_API ,  {credentials: 'include',});
    const data = await res.json();
    return data;
});


const industries = createSlice({
    name: 'industries',
    initialState: {},
    reducers: {
        addIndustries: (state, action) => {
            return { ...action.payload }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchIndustries.pending, (state, action) => {
            // state.isLoading = true;
        });
        builder.addCase(fetchIndustries.fulfilled, (state, action) => {
            // state.isLoading = false;
            // return action.payload;
        });
        // builder.addCase(fetchIndustries.rejected, (state, action) => {
        //     // state.isError = true;
        // });
    },
});

export const { addIndustries } = industries.actions;
export default industries.reducer;